import React, { Component } from 'react';
import './styles.scss';
import { Button, Card, CardBody, Col, CustomInput, Form, FormGroup, Input, Row } from 'reactstrap';
import { Link, withRouter } from 'react-router-dom';
import { ordersService } from '../../services/Orders';
import autobind from 'autobind-decorator';
import get from 'lodash.get';
import ProductCard from '../ProductCard';

class OrderCreateForm extends Component {
  selectedProducts = [
    // {
    //   id: '1',
    //   name: 'Бордовое базовое худи с флисом',
    //   img: 'https://images.ua.prom.st/1616027834_w640_h640_bryuki-muzhskie-yoshimitsu.jpg'
    // },
    // {
    //   id: '2',
    //   name: 'Желто-черная худи с белым вставками с флисом',
    //   img: 'https://oxxxyshop.com/wa-data/public/shop/products/08/01/108/images/487/487.750@2x.jpg'
    // },
    // {
    //   id: '3',
    //   name: 'Бордовое базовое худи с флисом',
    //   img: 'https://images.ua.prom.st/1616027834_w640_h640_bryuki-muzhskie-yoshimitsu.jpg'
    // }
  ];

  constructor(props) {
    super(props);

    ordersService.stopSelecting();
  }

  onClick() {
    ordersService.startSelecting();
  }

  @autobind
  onCancelClick() {
    ordersService.reset();
    console.log(this.props.location);
    this.props.history.push(get(this.props.location, 'state.from', '/'));
  }

  render() {
    return (
      <>
        <Row className="order-create-form">
          <Col xs={5}>
            <Card>
              <CardBody>
                <div className="filter-card_title">Поставщик</div>
                <Form>
                  <FormGroup>
                    <CustomInput type="select" id="exampleCustomSelect" name="customSelect">
                      <option value="">Drop Spot</option>
                      <option>Value 1</option>
                      <option>Value 2</option>
                      <option>Value 3</option>
                    </CustomInput>
                  </FormGroup>
                </Form>

                <hr/>

                <div className="filter-card_title">Получатель</div>
                <Form>
                  <FormGroup>
                    <Input type="text" name="phone" id="exampleEmail" placeholder="380XXXXXXXXX"/>
                  </FormGroup>
                  <Row form>
                    <Col md={6} style={{ paddingRight: '2.5px' }}>
                      <FormGroup>
                        <Input type="text" name="email" id="exampleEmail" placeholder="Имя"/>
                      </FormGroup>
                    </Col>
                    <Col md={6} style={{ paddingLeft: '2.5px' }}>
                      <FormGroup>
                        <Input type="text" name="password" id="examplePassword" placeholder="Фамилия"/>
                      </FormGroup>
                    </Col>
                  </Row>
                  <FormGroup>
                    <Input type="textarea" placeholder="Комментарий"></Input>
                  </FormGroup>
                </Form>

                <hr/>

                <div className="filter-card_title">Оплата</div>
                <Form>
                  <FormGroup>
                    <CustomInput type="radio" id="exampleCustomRadio" name="customRadio" checked label="Наложенный платеж"/>
                    <CustomInput type="radio" id="exampleCustomRadio2" name="customRadio" label="На карту"/>
                    <CustomInput type="radio" id="exampleCustomRadio3" name="customRadio" label="Самовывоз"/>

                    <CustomInput className="mt-2" type="checkbox" id="exampleCustomCheckbox" label="redBOX"/>
                  </FormGroup>
                </Form>

                <hr/>

                <div className="filter-card_title">Доставка</div>
                <Form>
                  <FormGroup>
                    <Input type="text" name="phone" id="exampleEmail" placeholder="Город"/>
                  </FormGroup>
                </Form>
              </CardBody>
            </Card>

            <div className="mt-3">
              <Button color="primary" disabled>Создать</Button>{' '}
              <Button color="link" onClick={this.onCancelClick}>Отменить</Button>
            </div>
          </Col>
          <Col xs={7}>
            <h4>Товары</h4>

            {!!this.selectedProducts.length && (
              <div className="product-list __small mb-2">
                {this.selectedProducts.map(product => <ProductCard product={product} key={product.id}/>)}
              </div>
            )}

            <Link to="/dropspot/products" onClick={() => this.onClick()}>
              <Button color="primary">Добавить товар</Button>
            </Link>
          </Col>
        </Row>
      </>
    );
  }
}

export default withRouter(OrderCreateForm);
